import {
    TActivateGiftResponse,
    TCardLinkEnrolledCardsResponse,
    TNewCardLinkEnrolledResponse,
} from '@/src/card-linking/api-client/cardLinkApiClientTypes'

export const getEnrolledCardsMock: TCardLinkEnrolledCardsResponse = {
    code: 200,
    message: 'SUCCESS',
    pagination: {
        limit: 20,
        offset: 0,
        total_count: 2,
    },
    data: [
        {
            id: '391f0f17-41c8-4d5e-9341-129c7ec2cb74',
            name: 'First LastName Mock',
            brand: 'visa',
            card_last_four: '4242',
            card_expiration: '08/24',
        },
        {
            id: 'c4c10eba-6c91-49e2-86b2-29b1de7f26ac',
            name: 'John Smith',
            brand: 'amex',
            card_last_four: '4242',
            card_expiration: '11/24',
        },
    ],
}

export const postEnrolledCardsMock: TNewCardLinkEnrolledResponse = {
    code: 200,
    message: 'SUCCESS',
    data: {
        id: '391f0f17-41c8-4d5e-9341-129c7ec2cb74',
        name: 'First LastName',
        brand: 'visa',
        card_last_four: '4242',
        card_expiration: '08/24',
    },
}

export const postActivateGiftMock: TActivateGiftResponse = {
    code: 201,
    message: 'SUCCESS',
    data: {
        enabled: true,
        gift: {
            id: '5d342541-a756-493f-b899-1a86cf2ecb36',
            amount: 500,
            balance: 500,
        },
        redemption_account: {
            id: '391f0f17-41c8-4d5e-9341-129c7ec2cb74',
            brand: 'visa',
            card_last_four: '4242',
            card_expiration: '08/24',
        },
    },
}
